import React, { useState } from 'react';
import { UtensilsCrossed } from 'lucide-react';
import { login } from '../../services/apiClient';
import logger from '../../utils/logger';
import { Button, Card } from '../ui';
import { Input } from '../ui/Field';

const Login = ({ apiUrl, onLoginSuccess }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    if (!username || !password) {
      logger.warn('Login attempt with missing credentials');
      setError('Por favor, preencha o nome de utilizador e a palavra-passe.');
      setLoading(false);
      return;
    }

    logger.info('Login attempt', { username });
    try {
      const data = await login(apiUrl, { username, password });
      if (data.token) {
        logger.info('Login successful', { username });
        onLoginSuccess(data.token);
      } else {
        logger.error('Login failed - no token in response', { data });
        setError(data.msg || data.message || 'Falha na autenticação. Credenciais inválidas.');
      }
    } catch (err) {
      logger.error('Login error', { error: err.message, username });
      setError(err.message || 'Erro de comunicação com o servidor. Verifique o IP.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-background p-4">
      {/* Ambient brand glows */}
      <div className="pointer-events-none absolute -top-32 -left-32 h-96 w-96 rounded-full bg-brand/20 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-32 -right-32 h-96 w-96 rounded-full bg-accent/20 blur-3xl" />

      <Card className="relative w-full max-w-md p-8 animate-slide-up">
        <div className="text-center">
          <span className="mx-auto grid h-14 w-14 place-items-center rounded-2xl gradient-brand text-white shadow-lg">
            <UtensilsCrossed className="h-7 w-7" />
          </span>
          <h1 className="mt-5 text-2xl font-extrabold tracking-tight">
            <span className="text-gradient-brand">TOMS</span>{' '}
            <span className="text-foreground">Admin</span>
          </h1>
          <p className="mt-2 text-sm text-muted">Faça login para gerir os seus restaurantes.</p>
        </div>

        {error && (
          <div className="mt-6 rounded-xl bg-status-canceled-soft px-4 py-3 text-sm text-status-canceled">
            {error}
          </div>
        )}

        <form className="mt-6 space-y-4" onSubmit={handleSubmit}>
          <Input
            label="Nome de Utilizador"
            id="username"
            name="username"
            type="text"
            required
            placeholder="e.g., toms_admin"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
          <Input
            label="Palavra-passe"
            id="password"
            name="password"
            type="password"
            required
            placeholder="••••••••"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <Button type="submit" size="lg" loading={loading} className="w-full">
            Entrar
          </Button>
        </form>

        <p className="mt-6 text-center text-[11px] text-muted-2 break-all">API: {apiUrl}</p>
      </Card>
    </div>
  );
};

export default Login;
